import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Paper } from '@mui/material';

const warningsData = [
  { id: 1, message: 'Warning: Medication stock low!', level: 'low' },
  { id: 2, message: 'Warning: Outbreak of Covid-19 nearby. Please take care!', level: 'high' },
  { id: 3, message: 'Warning: Your last appointment is overdue.', level: 'medium' },
  { id: 4, message: 'Warning: Update your insurance details.', level: 'medium' },
  { id: 5, message: 'Warning: Follow up with your doctor.', level: 'low' }
];

const levelStyles = {
  low: {
    backgroundColor: '#2E7D32', // Green for low-level warnings
    color: 'white'
  },
  medium: {
    backgroundColor: '#FFA726', // Orange for medium-level warnings
    color: 'black'
  },
  high: {
    backgroundColor: '#D32F2F', // Red for high-level warnings
    color: 'white'
  }
};

const WarningPage = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#121212',
        color: 'white',
        p: 4,
        pt: { xs: '4rem', sm: '4.5rem', md: '5rem' }
      }}
    >
      <Typography variant='h3' sx={{ mb: 4, fontWeight: 'bold', textAlign: 'center' }}>
        Warnings
      </Typography>
      <List>
        {warningsData.map((warning) => (
          <ListItem key={warning.id} sx={{ mb: 2 }}>
            <Paper
              elevation={3}
              sx={{
                width: '100%',
                borderRadius: '8px',
                p: 2,
                '&:hover': {
                  backgroundColor: (theme) => levelStyles[warning.level].backgroundColor === '#2E7D32'
                    ? '#3B9A3B'
                    : levelStyles[warning.level].backgroundColor === '#FFA726' ? '#FFB74D' : '#E57373',
                  cursor: 'pointer'
                },
                ...levelStyles[warning.level] // Apply the color styles based on level
              }}
            >
              <ListItemText primary={warning.message} />
            </Paper>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default WarningPage;
